var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "keyboard_double_arrow_left_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_18890",
    "data-name": "\\uADF8\\uB8F9 18890"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1794",
    "data-name": "\\uC0AC\\uAC01\\uD615 1794",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1795",
    "data-name": "\\uC0AC\\uAC01\\uD615 1795",
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_18892",
    "data-name": "\\uADF8\\uB8F9 18892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_18891",
    "data-name": "\\uADF8\\uB8F9 18891"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_45",
    "data-name": "\\uD328\\uC2A4 45",
    d: "M18.29,17.29h0a1,1,0,0,0,0-1.41L14.42,12,18.3,8.12a1,1,0,0,0,0-1.41h0a1,1,0,0,0-1.41,0L12.3,11.3a1,1,0,0,0,0,1.41l4.59,4.59A.993.993,0,0,0,18.29,17.29Z",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_46",
    "data-name": "\\uD328\\uC2A4 46",
    d: "M11.7,17.29h0a1,1,0,0,0,0-1.41L7.83,12l3.88-3.88a1,1,0,0,0,0-1.41h0a1,1,0,0,0-1.41,0L5.71,11.3a1,1,0,0,0,0,1.41L10.3,17.3A.993.993,0,0,0,11.7,17.29Z",
    fill: "#777"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowLeft);
export default __webpack_public_path__ + "static/media/double_arrow_left.f690ff3b5bfc129bc2688f95ba405aee.svg";
export { ForwardRef as ReactComponent };